// extracted by mini-css-extract-plugin
export default {"p":"Timer_p__fmT3O","red":"Timer_red__Ydymi","blue":"Timer_blue__i3tTI"};